module.exports = __webpack_public_path__ + "img/DCS.33ca857d.png";